import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions, noteActions } from '_actions';
import styles from './Header.module.css';
import { ChevronRightButton, ChevronDownButton, EditNoteButton, SpecialtyProgButton, HEPButton } from '_components';
import { getDateMDYY } from '_helpers'

class PatientHomeAdmissionHeader extends React.Component {

    getChevron() {
        if (this.props.visible) {
            return (<ChevronDownButton size='extra-small' className={styles.header_button} onClick={() => this.props.toggleVisibility({ epno: this.props.admission.id })} />)
        } else {
            return (<ChevronRightButton size='extra-small' className={styles.header_button} onClick={() => this.props.toggleVisibility({ epno: this.props.admission.id })} />)
        }
    }

    componentDidMount() {
        if (this.props.limberActive && this.props.epno) {
            this.props.loadLimber(this.props.epno);
        }
    }

    hepClicked() {
        this.props.openHEP(this.props.admission.id);
    }

    render() {
        if (this.props.admission.dischargeDate == null) {
            return (
                <div className={styles.admission_header}>
                    {this.getChevron()}
                    {!this.props.isAide && (!this.props.isATC || (this.props.isATC && this.props.admission.isWP)) &&
                        <EditNoteButton size='extra-small' title='Start Note' className={styles.header_button} onClick={() => this.props.startNote(this.props.admission.id, true)} />
                    }
                    <EditNoteButton size='extra-small' title='Start Scribed Note' className={styles.header_button_scribe} onClick={() => this.props.showScribeOptions(this.props.admission.id)} />

                    <SpecialtyProgButton size='extra-small' title='Request Specialty Program' className={styles.header_button} onClick={() => this.props.showSpecialProgReq({ epno: this.props.admission.id })} />
                    {this.props.hepEnabled &&
                        <HEPButton size='extra-small' title='Home Exercise Program' className={styles.header_button} onClick={() => this.hepClicked()} />
                    }
                    <span className={styles.header_text}>{
                        getDateMDYY(this.props.admission.startDate)
                        + ' - ' + this.props.admission.desc
                        + ' - ' + this.props.admission.discipline
                        + ' - ' + this.props.admission.lcid
                    }
                    </span>
                </div>
            );
        } else {
            return (
                <div className={styles.admission_header}>
                    {this.getChevron()}
                    <span className={styles.header_text}>{
                        getDateMDYY(this.props.admission.startDate)
                        + ' - ' + getDateMDYY(this.props.admission.dischargeDate)
                        + ' - ' + this.props.admission.desc
                        + ' - ' + this.props.admission.discipline
                        + ' - ' + this.props.admission.lcid
                    }
                    </span>
                </div>
            );
        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleVisibility: bindActionCreators(patientActions.toggleAdmissionVisibility, dispatch),
        showSpecialProgReq: bindActionCreators(patientActions.showSpecialProgReq, dispatch),
        startNote: bindActionCreators(noteActions.startNote, dispatch),
        showScribeOptions: bindActionCreators(patientActions.showScribeOptions, dispatch),
        openHEP: bindActionCreators(patientActions.openHEP, dispatch),
        loadLimber: bindActionCreators(patientActions.loadLimberAssessments, dispatch),
    };
}

function mapStateToProps(state, ownprops) {
    let isAide = state.entities.authentication.user.isAide;
    let isATC = state.entities.authentication.user.isATC;
    let hepEnabled = state.entities.masterData.PROPS['HEP-ENABLED'] && state.entities.masterData.PROPS['HEP-ENABLED'].PRVALUE === 'TRUE' ? true : false;
    let epno = ownprops.id;
    let ptno = state.ui.admissions[epno].ptno;
    let limberActive = state.entities.admissions[epno]?.limberActive;
    return {
        isAide,
        admission: state.entities.admissions[ownprops.id],
        visible: state.ui.admissions[ownprops.id].visible,
        hepEnabled,
        epno,
        ptno,
        limberActive,
        isATC,
    };
}

const connectedPatientHomeAdmissionHeader = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionHeader);
export { connectedPatientHomeAdmissionHeader as PatientHomeAdmissionHeader };

